<template>
  <div class="d-flex align-items-center">
    <div class="flex-shrink-1 mr-2 d-flex">
      <b-icon-heart-fill
        v-if="didLike"
        :font-scale="iconBig ? 1.5 : 1"
        v-on:click="likePost(postId, numberOfLikes, didLike)"
        class="likeIcon"
      />

      <b-icon-heart
        v-else
        :font-scale="iconBig ? 1.5 : 1"
        v-on:click="likePost(postId, numberOfLikes, didLike)"
        class="likeIcon"
      />
    </div>
    <div class="flex-grow-1 caption" v-if="!iconOnly">{{ numberOfLikes }} likes</div>
  </div>
</template>

<script>
export default {
  name: "Like",
  props: {
    numberOfLikes: Number,
    postId: Number,
    didLike: Boolean,
    likePost: Function,
    iconOnly: Boolean,
    iconBig: Boolean,
  },
};
</script>

<style scoped lang="scss">
.likeIcon {
  cursor: pointer;
  color: $color-red;
  width: 20px;
}
</style>
